module.exports = __webpack_public_path__ + "static/media/x-small.6641d0aa.svg";